import { useSplitTreatments, useSplitClient } from '@splitsoftware/splitio-react';
import { isFlagOn } from '../services/split.io';

export const useSplit = (treatmentName) => {
    const { treatments } = useSplitTreatments({ names: [treatmentName] });
    const { treatment } = treatments?.[treatmentName] || { treatment: '' };
    return { isOn: isFlagOn(treatment) };
};